import MainBlockLayout from '../../components/MainBlockLayout';
import { Row, Col, Nav, Tab, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Trans } from 'react-i18next';
import "react-image-gallery/styles/css/image-gallery.css";
import React, { useState } from "react";
import { YEAR_2023 } from '../../data/satteliteImagesData';
import { generateImageTabs } from "../../utils/common";
import NewsLetterAccordion from './components/NewsLetterAccordion';
import { useSelector } from 'react-redux';
import SchoolStatistics from './components/SchoolStatistics';
import SchoolSiteInfo from './components/SchoolSiteInfo';
import './styles/SchoolPage.css'; // We'll create this file


function MainBlock() {
    const { schoolName } = useParams();
    
    let [loading, setLoading] = useState(true);
    const [showBrochure, setShowBrochure] = useState(false);
    
    const NEWSLETTERS = useSelector(state => state.satelliteSchools.schools_newsletters);
    const newsletter = NEWSLETTERS[schoolName];
    const schoolImages = YEAR_2023[schoolName];

    const school = useSelector((state) =>
        state.satelliteSchools.schools_list.find((s) => s.name === schoolName)
    );

    let addComponent = () => {
        if(schoolName === "tunbridge"){
            return [<><Trans ns="sateliteSchools" i18nKey={`${schoolName} form`} /> <a href="https://forms.gle/iyNw8YurMwJLqX1Z8">https://forms.gle/iyNw8YurMwJLqX1Z8 </a></>]
        }
     }

    return (
        <>
        
            <Row className="align-items-center mb-4 ">
                <Col className='text-center d-flex flex-row justify-content-center align-items-center gap-3' >
                    <h1 className="display-5 m-0 fw-bold schoolNameTextColor">
                        <Trans ns="sateliteSchools" i18nKey={`${schoolName}`} />
                    </h1>
                
                
                    <Button as="a" href={school.registerLink} target="_blank" rel="noopener" variant="primary" size="lg" className='btn-register-form'>
                        <Trans i18nKey="Register Button" />
                    </Button>
                </Col>
            </Row>
            
            <Row>
                <article className="card d-flex flex-column w-100 border-0 rounded-4 overflow-hidden p-0">
                    <div className="row g-0 align-items-center justify-content-center">
                        {/* School Photo */}
                        <div className="col-12 col-md-7">
                            <img
                                src={school.schoolPhoto}
                                alt={`${schoolName} school photo`}
                                className="school-photo w-100"
                            />
                        </div>
                        
                        {/* School Information Section with Statistics below */}
                        <div className="col-10 col-md-5 d-flex flex-column">
                            <div className="school-info-container">
                                <SchoolSiteInfo schoolName={schoolName} />
                            </div>
                            
                            {/* Statistics moved inside this column for desktop */}
                            <div className="col-12 statistics-row-wrapper d-none d-md-block">
                                <SchoolStatistics schoolName={schoolName} />
                            </div>
                        </div>
                    </div>
                    
                    {/* Statistics Row for mobile - Only visible on smaller screens */}
                    <div className="row g-0 align-items-center d-md-none">
                        <div className="col-12 statistics-row-wrapper">
                            <SchoolStatistics schoolName={schoolName} />
                        </div>
                    </div>
                </article>
            </Row>


                <Row>
                    <Col>
                        <h2 className="justify-content-center d-flex mt-3"><Trans i18nKey="about us" /></h2>
                        <p>
                            <Trans ns="sateliteSchools" i18nKey={`${schoolName} about`} />
                            {addComponent()}
                        </p>
                    </Col>

                    <h2 className="justify-content-center d-flex mt-5"><Trans i18nKey="Gallery" /></h2>
                    <div style={{ marginTop: "25px" }}>

                        <Tab.Container id="left-tabs-example" defaultActiveKey="2023">
                            <Row className="justify-content-center d-flex">
                                <Col sm={3}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="2023" onClick={() => setLoading(true)}>2023</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                            </Row>

                            <Row className="justify-content-center d-flex">
                                <Col sm={9}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="2023">
                                            {generateImageTabs(schoolImages, loading, setLoading, "right")}
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </div>
                    { newsletter ?
                    <NewsLetterAccordion newsLetters={newsletter} showBrochure={showBrochure} setShowBrochure={setShowBrochure}/> 
                    : "" } 
                </Row>
                
        </>
    )
}

export default MainBlockLayout(MainBlock);